import { useGetCurrentTermByRoleAndTypeQuery, TermType } from '@platform/data-access'
import type { Role, TermType as TermTypeProps } from '@platform/data-access'
import { formatDate } from '@platform/utils'

import styles from './index.module.scss'

const TERMS_TITLE = {
  [TermType.CookiePolicy]: 'Cookie Policy',
  [TermType.PrivacyPolicy]: 'Privacy Policy',
  [TermType.TermsOfUse]: 'Terms of Use',
}
type TermsProps = {
  role: Role
  type: TermTypeProps
  isFetchEnabled?: boolean
}

export const Terms = ({ role, type, isFetchEnabled = true }: TermsProps) => {
  const { data } = useGetCurrentTermByRoleAndTypeQuery(
    {
      input: { role: role, type: type },
    },
    { enabled: isFetchEnabled }
  )

  if (!data?.getCurrentTermByRoleAndType?.textHtml) {
    return null
  }

  return (
    <div className={styles['container']}>
      <div className={styles['content']}>
        <h1 className={styles['heading']}>{TERMS_TITLE[type]}</h1>
        <p className={styles['version']}>{`Version ${
          data?.getCurrentTermByRoleAndType?.versionName
        } • Updated on ${formatDate(
          data?.getCurrentTermByRoleAndType?.versionDate,
          'MMM dd, yyyy'
        )}`}</p>
        <hr className={styles['divisor']} />
        <div
          className={styles['terms']}
          dangerouslySetInnerHTML={{ __html: data.getCurrentTermByRoleAndType.textHtml }}
        />
      </div>
    </div>
  )
}

export default Terms
